<template>
  <div>
    <EmptyState v-if="loading == true" :height="170">
      <div slot="empty_state_text">
        Loading Images
      </div>
    </EmptyState>

    <agile :arrows="false" :speed="800" :timing="'linear'" :fade="false" :autoplay="false" :pauseOnHover="false" v-else>
      <div class="slide" v-for="(item,i) in images" :class="`slide--${i}`" @click="zoomImage(item)">
        <img :key="i" :src="formatImage(item)" height="auto" width="200px" max-height="500px">
      </div>
    </agile>
  </div>
</template>

<script>
import EmptyState from '@/components/common/EmptyState'
export default {
  props: ['product', 'session', 'type'],
  components: { EmptyState },
  data: function () {
    return {
      images: [],
      loading: true
    }
  },
  mounted: function () {
    this.getFinalImages()
  },
  methods: {
    getFinalImages: function () {
      var self = this

      const url = '/imagedesk/image/final'
      let data = {
        id_product: self.product.id_product,
        is_only_mapped: 1
      }

      self.loading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.images = response.data.final_images
          self.loading = false
        })
        .catch(function (error) {
          self.loading = false
          self.$store.dispatch('updateToast', {
            text:
             'Images not found',
            show: true
          })
        })
    },
    formatImage: function (image) {
      return (
        (image && image.host + image.raw_thumb_location) ||
        'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      )
    },
    zoomImage: function (image) {
      var context = {
        content: image,
        contentType: 'image',
        show: true
      }
      this.$store.dispatch('updateModal', context)
    }
  },
  watch: {
    product () {
      this.getFinalImages()
    },
    images () {}
  }
}
</script>

<style scoped>
.agile {
  width: 200px !important;
}
.agile__dots {
  bottom: 0;
  display: block;
  left: 10px;
  position: absolute;
  width: 30px;
}
.agile__dot {
  margin-bottom: 10px;
}
.agile__dot button {
  background-color: transparent;
  border: 1px solid #fff;
  margin-top: 10px;
}
.agile__dot button:hover {
  background-color: #fff;
}
.agile__dot--current button {
  background-color: #fff;
}

.slide {
  background-position: center;
  background-size: cover;
  width: 200px;
  text-align: center;
}
</style>
